export enum SharedResource {
  ROUND_TRANSACTION = "ROUND TRANSACTION",
  ROUND_CREATION_SUMMARY = "ROUND CREATION SUMMARY",
  DASHBOARD = "DASHBOARD",
  NON_PRICED_ROUND_MODEL = "NON PRICED ROUND MODEL",
  PRICED_ROUND_MODEL = "PRICED ROUND MODEL",
  BENEFICIARY = "BENEFICIARY",
}
